/**
 * Myntra-Style Better Discount Sort
 * Calculates discount percentage and sorts products accordingly
 */

const MyntraBetterDiscountSort = (function () {
    return {
        init: function () {
            console.log('🎯 Discount Sort Initialized');
            this.setupDiscountSort();
        },

        calculateDiscountPercent: function (product) {
            // Try multiple selectors for compare price (MRP)
            const comparePrice = product.querySelector('.compare-price, .price__sale .price-item, s.price-item');
            // Try multiple selectors for regular price (selling price)
            const regularPrice = product.querySelector('.price__regular, .special-price, .price__regular.special-price');

            if (!comparePrice || !regularPrice) {
                console.log('❌ Price elements not found for product');
                return 0;
            }

            // Get text content
            const comparePriceText = comparePrice.textContent || comparePrice.innerText || '';
            const regularPriceText = regularPrice.textContent || regularPrice.innerText || '';

            console.log('Compare Price Text:', comparePriceText);
            console.log('Regular Price Text:', regularPriceText);

            // Extract numbers from price strings (handles ₹, Rs., commas, etc.)
            const comparePriceValue = parseFloat(comparePriceText.replace(/[^0-9.]/g, ''));
            const regularPriceValue = parseFloat(regularPriceText.replace(/[^0-9.]/g, ''));

            console.log('Compare Price Value:', comparePriceValue);
            console.log('Regular Price Value:', regularPriceValue);

            if (!comparePriceValue || !regularPriceValue || comparePriceValue <= regularPriceValue) {
                console.log('⚠️ No valid discount found');
                return 0;
            }

            const discount = ((comparePriceValue - regularPriceValue) / comparePriceValue) * 100;
            const roundedDiscount = Math.round(discount);

            console.log(`✅ Discount calculated: ${roundedDiscount}%`);
            return roundedDiscount;
        },

        addDiscountBadge: function (product, discount) {
            if (discount <= 0) return;

            // Check if badge already exists
            if (product.querySelector('.myntra-discount-badge')) {
                console.log('Badge already exists, skipping');
                return;
            }

            // Create discount badge
            const badge = document.createElement('div');
            badge.className = 'myntra-discount-badge';
            badge.textContent = `${discount}% OFF`;
            badge.style.cssText = `
                position: absolute;
                top: 10px;
                left: 10px;
                background: #ff3f6c;
                color: white;
                padding: 5px 10px;
                font-size: 12px;
                font-weight: 700;
                border-radius: 3px;
                z-index: 10;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            `;

            // Find product image container
            const imgContainer = product.querySelector('.bls__product-img');
            if (imgContainer) {
                if (window.getComputedStyle(imgContainer).position === 'static') {
                    imgContainer.style.position = 'relative';
                }
                imgContainer.appendChild(badge);
                console.log(`✅ Badge added: ${discount}% OFF`);
            } else {
                console.log('❌ Image container not found for badge');
            }
        },

        sortByDiscount: function () {
            console.log('🔄 Starting discount sort...');

            const productGrid = document.querySelector('#bls__product-grid');
            if (!productGrid) {
                console.log('❌ Product grid not found');
                return;
            }

            const products = Array.from(productGrid.querySelectorAll('.bls__grid__item'));

            console.log(`📦 Found ${products.length} products to sort`);

            if (products.length === 0) {
                console.log('⚠️ No products found to sort');
                return;
            }

            // Calculate discount for each product
            let productsWithDiscount = 0;
            products.forEach((product, index) => {
                console.log(`\n--- Product ${index + 1} ---`);
                const discount = this.calculateDiscountPercent(product);
                product.setAttribute('data-discount', discount);

                // Add discount badge
                if (discount > 0) {
                    this.addDiscountBadge(product, discount);
                    productsWithDiscount++;
                }
            });

            console.log(`\n💰 Products with discount: ${productsWithDiscount}/${products.length}`);

            // Sort by discount percentage (highest first)
            products.sort((a, b) => {
                const discountA = parseInt(a.getAttribute('data-discount')) || 0;
                const discountB = parseInt(b.getAttribute('data-discount')) || 0;
                return discountB - discountA;
            });

            // Re-append products in sorted order
            products.forEach(product => {
                productGrid.appendChild(product);
            });

            console.log('✅ Products sorted by discount percentage (highest first)');
            console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
        },

        setupDiscountSort: function () {
            // Check if Better Discount sort is active
            const checkSortValue = () => {
                const urlParams = new URLSearchParams(window.location.search);
                const sortBy = urlParams.get('sort_by');

                console.log('Current sort_by:', sortBy);

                if (sortBy === 'discount-descending') {
                    console.log('🎯 Discount sort triggered!');
                    // Small delay to ensure products are loaded
                    setTimeout(() => {
                        this.sortByDiscount();
                    }, 300);
                }
            };

            // Initial check
            checkSortValue();

            // Listen for URL changes (for filtering)
            window.addEventListener('popstate', () => {
                console.log('URL changed (popstate)');
                checkSortValue();
            });
        }
    }
})();

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        MyntraBetterDiscountSort.init();
    });
} else {
    MyntraBetterDiscountSort.init();
}
